<script lang="ts">
  import { Edit, href } from "../../../utils/Constant/Constant";
  import Link from "svelte-link";
  import {editForm,personalContact} from "../../../store"
  export let getId:number
  let setEditForm:boolean
  editForm.subscribe((value) => {
    setEditForm = value
  })
  let setPersonalContact:number
    personalContact.subscribe((value)=>{
        setPersonalContact = value
    })
  // for user detail edit
  const toggle = (id:number) => {
    if(setPersonalContact == id){
      editForm.update(value => value = !value)
    }
  };
</script>
<li>
    <Link href={href} on:click={()=>toggle(getId)}>{Edit}</Link>
</li>
